function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.68 28.825A2 2 0 017.5 27v-2h-2A2.5 2.5 0 013 22.5v-16A2.5 2.5 0 015.5 4h21A2.5 2.5 0 0129 6.5v16a2.5 2.5 0 01-2.5 2.5H14.76l-3.931 3.495a2 2 0 01-2.148.33zM9.5 27v-3.5A.5.5 0 009 23H5.5a.5.5 0 01-.5-.5v-16a.5.5 0 01.5-.5h21a.5.5 0 01.5.5v16a.5.5 0 01-.5.5H14.76a2 2 0 00-1.328.505L9.5 27z",
  fill: "currentColor"
})));